import { AuthGuard, roleGuard } from "@dis/auth";
import { JtmsRoutes, tablesLayout } from "../core/routing/route-data";

// Component detail waits for an id-keyed lookup (today it keys on serial number).
export default [
  {
    path: "",
    canMatch: [AuthGuard],
    data: { navGroup: "shop" },
    children: [
      {
        path: "",
        pathMatch: "full",
        data: { navOrder: 0, castable: true },
        loadComponent: () =>
          import("../feature/shop/inventory/inventory-summary-kpi/inventory-summary-kpi").then(
            (m) => m.InventorySummaryKpi
          ),
        title: "Overview",
      },
      {
        path: "inventory",
        children: [
          {
            path: "",
            pathMatch: "full",
            data: { navOrder: 1 },
            loadComponent: () =>
              import("../feature/shop/inventory/inventory-review/inventory-review").then((m) => m.InventoryReview),
            title: "Inventory",
          },
          {
            path: "map",
            data: { navOrder: 2 },
            loadComponent: () =>
              import("../feature/shop/inventory/inventory-map/inventory-map.component").then(
                (m) => m.InventoryMapComponent
              ),
            title: "Inventory Map",
          },
          {
            path: "move",
            data: { navOrder: 3 },
            loadComponent: () =>
              import("../feature/shop/inventory/inventory-move-item/inventory-move-item.component").then(
                (m) => m.InventoryMoveItemComponent
              ),
            title: "Move Item",
          },
          {
            path: "adjust",
            data: { navOrder: 4 },
            loadComponent: () =>
              import("../feature/shop/inventory/inventory-adjustment/inventory-adjustment.component").then(
                (m) => m.InventoryAdjustment
              ),
            title: "Adjust Lots",
          },
          {
            path: "labels",
            data: { navOrder: 5 },
            loadComponent: () =>
              import("../feature/shop/inventory/print-labels/print-labels").then((m) => m.PrintLabels),
            title: "Print Labels",
          },
          {
            path: "shear-pins",
            data: { navOrder: 6 },
            loadComponent: () =>
              import("../feature/shop/inventory/cut-shear-pins/cut-shear-pins").then((m) => m.CutShearPins),
            title: "Cut Shear Pins",
          },
          {
            // Admin-only, as at /settings/inventory-types; revisit with the group guards.
            path: "types",
            data: { navOrder: 11, adminOnly: true },
            canActivate: [roleGuard(["admin", "super_admin"])],
            loadComponent: () =>
              import("../feature/settings/inventory-types/inventory-types").then((m) => m.InventoryTypes),
            title: "Inventory Types",
          },
        ],
      },
      {
        path: "components",
        pathMatch: "full",
        loadComponent: tablesLayout,
        children: [
          {
            path: "",
            data: { navOrder: 7 },
            loadComponent: () =>
              import("../feature/components/components-ag-grid/components-ag-grid.component").then(
                (m) => m.ComponentsAgGridComponent
              ),
            title: "Components",
          },
        ],
      },
      {
        path: "containers",
        pathMatch: "full",
        loadComponent: tablesLayout,
        children: [
          {
            path: "",
            data: { navOrder: 8 },
            loadComponent: () =>
              import("../containers/container-table/container-table.component").then((m) => m.ContainerTable),
            title: "Containers",
          },
        ],
      },
      {
        path: "receiving",
        data: { navOrder: 9 },
        loadComponent: () =>
          import("../feature/shop/ship-n-receiving/receive-tools/receive-tools.component").then((m) => m.ReceiveTools),
        title: "Receiving",
      },
      {
        path: "work-orders",
        data: { navOrder: 10 },
        loadComponent: () =>
          import("../feature/shop/operations/work-order-list/work-order-list.component").then((m) => m.WorkOrderList),
        title: "Work Orders",
      },
      {
        // Legacy /shop/* routes (inventory/*, ship-n-receiving/*, operations/*) until redirects replace them.
        path: "",
        loadChildren: () => import("../feature/shop/shop.routes"),
      },
    ],
  },
] satisfies JtmsRoutes;
